/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type ScoreDataType =
  | "NUMERIC"
  | "BOOLEAN"
  | "CATEGORICAL"
  | "CORRECTION";
export const ScoreDataType = {
  Numeric: "NUMERIC",
  Boolean: "BOOLEAN",
  Categorical: "CATEGORICAL",
  Correction: "CORRECTION",
} as const;
